

export namespace ClickActions
{
  export class Types
  {
    public static AddToCart = 'cart';
    public static Redirect = 'redirect';
  }
}